module.exports = __webpack_public_path__ + "static/img/point_icon_12.39fc8eab.svg";